/** Public CMS org slug — must match `organizations.slug` in Hub (overridable via env). */
export const ORG_SLUG = import.meta.env.VITE_PUBLIC_ORG_SLUG || 'bnkr-digital-agency'

const base =
  import.meta.env.VITE_PUBLIC_API_URL || import.meta.env.VITE_API_URL || ''
export const apiBase = base ? `${base.replace(/\/$/, '')}/api` : '/api'

export function publicUrl(path: string) {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${apiBase}/public/${ORG_SLUG}${p}`
}
